import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', color: '#333', lineHeight: '1.6', margin: '0', padding: '0', boxSizing: 'border-box' }}>
      {/* Meta Tags for SEO */}
      <head>
        <title>Privacy Policy and Terms of Use | ALINA Invisible Braces</title>
        <meta name="description" content="Privacy Policy and Terms of Use for ALINA Invisible Braces." />
        <meta property="og:title" content="Privacy Policy and Terms of Use | ALINA Invisible Braces" />
        <meta property="og:description" content="Learn about how ALINA Invisible Braces collects and uses personal information, and the terms of use for our services." />
        <meta property="og:image" content="https://www.alinainvisiblebraces.com/wp-content/uploads/2024/02/alina_l.png" />
        <meta property="og:url" content="https://www.alinainvisiblebraces.com/privacy-policy-and-terms-of-use" />
      </head>

      {/* Header */}
      <header style={{ backgroundImage: 'url(https://example.com/path-to-your-image.jpg)', backgroundSize: 'cover', backgroundPosition: 'center', padding: '60px 20px', textAlign: 'center', color: 'white' }}>
        <h1 style={{ fontSize: '2.5em', margin: '0' }}>Privacy Policy and Terms of Use</h1>
      </header>

      {/* Main Content */}
      <main style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
        {/* Terms of Use Section */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#0066cc', fontSize: '1.8em' }}>Terms of Use</h2>
          <p><strong>Last Updated:</strong> October 25, 2024</p>
          <p>Welcome to https://www.alinainvisiblebraces.com (the “Site”). This Site is owned and operated by McKinley Dental Prosthetics Inc. (“Alina Invisible Braces,” “ALINA,” "Company," "we," "our," or "us"). By accessing or using our Site, including any interactive features such as the AI chatbot (the "Chatbot"), you agree to comply with and be bound by these Terms of Use ("Terms"). If you do not agree to these Terms, please do not use the Site or the Chatbot.</p>

          <h3>1. Acceptance of Terms</h3>
          <p>By accessing or using the Site or interacting with the Chatbot, you acknowledge that you have read, understood, and agree to be bound by these Terms and our Privacy Policy. If you are under 18 years of age, you must obtain parental or guardian consent to use the Site. If you do not obtain their consent, you must stop using this site.</p>

          <h3>2. Changes to Terms</h3>
          <p>We reserve the right to modify these Terms at any time without prior notice. The revised Terms will be posted on the Site, and your continued use of the Site or Chatbot after changes have been posted constitutes your acceptance of the updated Terms.</p>

          <h3>3. Use of the Site and Chatbot</h3>
          <p>You may use the Site and Chatbot for lawful purposes only. You agree not to:</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Use the Site or Chatbot in any way that violates applicable laws or regulations.</li>
            <li>Upload or transmit any viruses, malicious code, or harmful content.</li>
            <li>Attempt to gain unauthorized access to the Site, Chatbot, or any related systems or networks.</li>
          </ul>

          <h3>4. AI Chatbot Functionality</h3>
          <p>The Chatbot available on the Site is designed to provide customer support, answer frequently asked questions, and offer general information about our products and services. It is powered by artificial intelligence and aims to improve your user experience.</p>
          <p><strong>Limitations:</strong> The Chatbot is not intended to provide medical or dental advice or make any health-related recommendations. Always consult a licensed dental professional before making decisions about your treatment.</p>
          <p>Conversations with the Chatbot are not recorded or stored, except for personal information collected when you book an appointment through the Chatbot, such as your name, contact information, and appointment details.</p>

          <h3>5. Intellectual Property</h3>
          <p>All content on the Site, including but not limited to text, images, logos, videos, and software, is the intellectual property of Alina Invisible Braces or its content providers and is protected by applicable copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, modify, or create derivative works of any part of the Site or Chatbot content without our express written consent.</p>

          <h3>6. Third-Party Links</h3>
          <p>The Site may contain links to third-party websites or services. These links are provided for your convenience, and we are not responsible for the content, privacy practices, or terms of service of third-party websites. We recommend you review the terms of use and privacy policies of any third-party websites you visit.</p>

          <h3>7. Disclaimer of Warranties</h3>
          <p>The Site and Chatbot are provided on an "as-is" and "as-available" basis without warranties of any kind, either express or implied. We do not warrant that the Site or Chatbot will be uninterrupted, error-free, or free from harmful components.</p>

          <h3>8. Limitation of Liability</h3>
          <p>To the fullest extent permitted by law, Alina Invisible Braces shall not be liable for any damages arising out of or related to your use or inability to use the Site or Chatbot, including but not limited to indirect, incidental, punitive, and consequential damages.</p>

          <h3>9. Indemnification</h3>
          <p>You agree to indemnify, defend, and hold harmless Alina Invisible Braces and its affiliates from and against any claims, liabilities, damages, losses, and expenses arising out of your use of the Site or Chatbot or your violation of these Terms.</p>

          <h3>10. Governing Law</h3>
          <p>These Terms and any disputes arising from your use of the Site or Chatbot will be governed by and construed in accordance with the laws of the Philippines, without regard to its conflict of law principles.</p>

          <h3>11. Contact Us</h3>
          <p>If you have any questions regarding these Terms, please contact us at:</p>
          <p>Alina Invisible Braces<br />
            Phone: +63917-626-5348<br />
            Email: info@alinaaligner.com.ph</p>
        </section>
        
        {/* Privacy Policy Section */}
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ color: '#0066cc', fontSize: '1.8em' }}>Privacy Policy</h2>
          <p><strong>Last Updated:</strong> October 25, 2024</p>
          <p>McKinley Dental Prosthetics Inc. (“Alina Invisible Braces,” “ALINA,” "we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and disclose your personal information when you visit our website https://www.alinainvisiblebraces.com (the "Site") or interact with our AI chatbot (the "Chatbot").</p>
          
          <h3>1. Information We Collect</h3>
          <p>We collect various types of information when you interact with our Site and Chatbot. The types of information we collect include:</p>
          <h4>a. Personal Information</h4>
          <p>Personal information you provide to us, including but not limited to:</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Address</li>
            <li>Payment information (if applicable)</li>
          </ul>
          
          <h4>b. Automatically Collected Information</h4>
          <p>When you visit the Site or use the Chatbot, we may automatically collect information about your device and usage patterns, such as:</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>IP address</li>
            <li>Browser type</li>
            <li>Operating system</li>
            <li>Pages visited and duration</li>
            <li>Chatbot interactions</li>
          </ul>

          <h4>c. Chatbot Conversations</h4>
          <p>Conversations with the Chatbot will not be recorded or stored, except when you provide personal information to book an appointment (such as your name, contact information, and appointment details). This information will be used solely for appointment scheduling and related communications.</p>

          <h3>2. Use of Information</h3>
          <p>We use the information we collect to:</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Provide and improve our products and services.</li>
            <li>Respond to your inquiries and provide customer support.</li>
            <li>Process transactions and send order-related communications.</li>
            <li>Monitor usage patterns and analyze trends to improve our Site and Chatbot.</li>
            <li>Send marketing communications, if you have opted in.</li>
          </ul>

          <h3>3. Cookies and Tracking Technologies</h3>
          <p>We use cookies and similar technologies to enhance your experience on our Site. Cookies are small data files stored on your device that help us recognize repeat visitors, remember user preferences, and track Site performance. You can control cookie preferences through your browser settings, though disabling cookies may affect your ability to use certain features of the Site.</p>

          <h3>4. Sharing of Information</h3>
          <p>We do not sell your personal information. However, we may share your information in the following circumstances:</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>With service providers who assist us in operating the Site and providing services.</li>
            <li>In response to legal obligations, court orders, or requests from government authorities.</li>
            <li>If we are involved in a merger, acquisition, or sale of assets, your information may be transferred as part of that transaction.</li>
          </ul>

          <h3>5. Data Security</h3>
          <p>We implement reasonable security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure. We cannot guarantee absolute security.</p>

          <h3>6. Your Rights</h3>
          <p>You have the right to:</p>
          <ul style={{ paddingLeft: '20px' }}>
            <li>Access and review the personal information we hold about you.</li>
            <li>Request corrections or updates to your personal information.</li>
            <li>Request the deletion of your personal information, subject to certain exceptions.</li>
            <li>Opt-out of receiving marketing communications.</li>
            <li>Withdraw your consent to the processing of your personal information, where consent is the basis for processing.</li>
            <li>Restrict or object to the processing of your personal information under certain circumstances.</li>
            <li>Request the transfer of your personal information to another organization (data portability), where applicable.</li>
            <li>Be informed about the purposes for which your personal information is being processed.</li>
            <li>Lodge a complaint with the National Privacy Commission if you believe your data protection rights have been violated.</li>
            <li>Be notified in the event of a data breach that affects your personal information, where required by law.</li>
          </ul>
          <p>To exercise any of these rights, please contact us at <a href="mailto:dpomckinley@gmail.com">dpomckinley@gmail.com</a>.</p>

          <h3>7. Children's Privacy</h3>
          <p>Our Site and Chatbot are not intended for use by children under the age of 13. We do not knowingly collect personal information from children under 13. If we learn that we have collected information from a child under 13, we will delete it as soon as possible.</p>

          <h3>8. Changes to This Policy</h3>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated date, and your continued use of the Site or Chatbot after changes have been posted constitutes your acceptance of the updated policy.</p>

          <h3>9. Contact Us</h3>
          <p>If you have any questions or concerns about this Privacy Policy, please contact our Data Protection Officer at:</p>
          <p>Data Protection Officer<br />
            Alina Invisible Braces<br />
            7th Ave cor. Lane P, High Street, BGC, Taguig<br />
            Phone: +63917-626-5348<br />
            Email: <a href="mailto:dpomckinley@gmail.com">dpomckinley@gmail.com</a></p>
        </section>
      </main>

      {/* Footer */}
      <footer style={{ backgroundColor: '#333', color: 'white', textAlign: 'center', padding: '15px' }}>
        <p>&copy; 2024 ALINA Invisible Braces. All rights reserved.</p>
        <p>Contact: <a href="mailto:info@alinaaligner.com.ph" style={{ color: '#aaa' }}>info@alinaaligner.com.ph</a></p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
